import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreDataSecurityAppUsersSlice } from './get';

import { coreDataSecurityAppUsersByAppIdReducers, coreDataSecurityAppUsersByAppIdWatchers } from './_id';

export const coreDataSecurityAppUsersReducers = combineReducers({
	byAppId: coreDataSecurityAppUsersByAppIdReducers,
	get: getCoreDataSecurityAppUsersSlice.asyncReducers
});

export const coreDataSecurityAppUsersWatchers = combineAllWatchers([
	coreDataSecurityAppUsersByAppIdWatchers,
	getCoreDataSecurityAppUsersSlice.asyncWatchers
]);
